import { em } from 'polished'
import styled from 'styled-components'

import { Row } from 'styles/components/layout'

export const RowStyled = styled(Row)`
  margin-bottom: ${em(40)};
`
